export function getSeverityIcon(severity) {
  switch (severity) {
    case "danger":
      return "ico-alert";
    case "info":
      return "ico-info-circle";
    case "success":
      return "ico-check";
    case "warning":
      return "ico-alert";
  }
  return null;
}
